function toNumber(value) {
    if (value == null || value === '') {
        return null;
    }
    const number = Number(value);
    return Number.isNaN(number) ? null : number;
}

/**
 * Compare actual order amount against max stock / recommended qty.
 * Priority: over-max > over-capacity > above-recommended > below-recommended.
 */
export function getActualOrderAmountTone(item) {
    const actual = toNumber(item?.actualOrderAmount);
    if (actual == null) {
        return null;
    }
    const maxStock = toNumber(item?.maxStock);
    const currentStock = toNumber(item?.currentStock);
    const recommended = toNumber(item?.recommendedOrderAmount);

    if (maxStock != null && actual > maxStock) {
        return 'over-max';
    }
    if (maxStock != null && currentStock != null && (currentStock + actual) > maxStock) {
        return 'over-capacity';
    }
    if (recommended != null && actual > recommended) {
        return 'above-recommended';
    }
    if (recommended != null && actual < recommended) {
        return 'below-recommended';
    }
    return null;
}

export function getActualOrderAmountHighlightColor(item) {
    const tone = getActualOrderAmountTone(item);
    if (tone === 'over-max') {
        return '#e81123';
    }
    if (tone === 'over-capacity') {
        return '#FFCC00';
    }
    if (tone === 'above-recommended') {
        return '#f59e0b';
    }
    if (tone === 'below-recommended') {
        return '#3b82f6';
    }
    return null;
}

export function calculateOrderAmountFromBoxes(boxCount, unitsPerBox) {
    const boxes = toNumber(boxCount);
    const perBox = toNumber(unitsPerBox);
    if (boxes == null || perBox == null) {
        return null;
    }
    return boxes * perBox;
}

export function deriveOrderBoxCount(actualOrderAmount, unitsPerBox) {
    const actual = toNumber(actualOrderAmount);
    const perBox = toNumber(unitsPerBox);
    if (actual == null || perBox == null || perBox === 0) {
        return null;
    }
    const boxes = actual / perBox;
    if (!Number.isFinite(boxes) || boxes < 0) {
        return null;
    }
    // Whole boxes only; ceil so derived qty covers recommended/actual need.
    return Math.ceil(boxes);
}
